import {http} from '@/helpers/http-helper';

export const getPermissions = () => {
    return new Promise( (resolve, reject) => {
        const url = 'permissions';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};